import Card from '../UI/Card';
import BookItem from './BookItem/BookItem';
import classes from './AvailableBooks.module.css';
import results from '../../data/test.json'

const AvailableBooks = () => {
  const BooksList = results.results.map((Book) => {
    let coverImage = Book.formats['image/jpeg'];

    return(
      <BookItem
      key={Book.id}
      id={Book.id}
      name={Book.title}
      description={Book.authors.map(author => author.name).join(", ")} 
      subjects={Book.subjects}
      price={Book.price} 
      image={coverImage} 
    />
    )
  
  });

  return (
    <section className={classes.books}>
      <Card>
        <ul>{BooksList}</ul>
      </Card>
    </section>
  );
};

export default AvailableBooks;

